import React from "react";
import { PDFViewer } from "@react-pdf/renderer";
import Button from "@material-ui/core/Button";
import TipoMateria from "./Templates/ReporteMateria";
import TipoUsuario from "./Templates/ReporteUsuario";
import TipoMonto from "./Templates/ReporteMonto";
import TipoAmpRes from "./Templates/ReporteAmpResueltos";
import TipoApelacion from "./Templates/ReporteApelacion";
import TipoFechFutu from "./Templates/ReporteFechasFuturas";
import TipoCasoC from "./Templates/ReporteCasoC";
import TipoCaso from "./Templates/ReporteCaso";

class PdfGenerador extends React.Component {
  render() {
    console.log(this.props, "la cagada que recibe el generador");
    if (this.props.cliente) {
      switch (this.props.tipoReporte) {
        case "0":
          return (
            <div>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "flex-end"
                }}
              >
                <Button
                  variant="contained"
                  color="primary"
                  onClick={this.props.showReport}
                >
                  Volver
                </Button>
              </div>
              <PDFViewer style={{ width: "80%", height: "100vh" }}>
                <TipoMateria
                  data={this.props.reports}
                  filtros={this.props.filtros}
                  telefono={this.props.telefono}
                  direccion={this.props.direccion}
                  ciudad={this.props.ciudad}
                  url={this.props.url}
                />
              </PDFViewer>
            </div>
          );
        case "1":
          return (
            <div>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "flex-end"
                }}
              >
                <Button
                  variant="contained"
                  color="primary"
                  onClick={this.props.showReport}
                >
                  Volver
                </Button>
              </div>
              <PDFViewer style={{ width: "80%", height: "100vh" }}>
                <TipoUsuario
                  data={this.props.reports}
                  filtros={this.props.filtros}
                  telefono={this.props.telefono}
                  direccion={this.props.direccion}
                  ciudad={this.props.ciudad}
                  url={this.props.url}
                />
              </PDFViewer>
            </div>
          );
        case "2":
          return (
            <div>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "flex-end"
                }}
              >
                <Button
                  variant="contained"
                  color="primary"
                  onClick={this.props.showReport}
                >
                  Volver
                </Button>
              </div>
              <PDFViewer style={{ width: "80%", height: "100vh" }}>
                <TipoCaso
                  data={this.props.reports}
                  filtros={this.props.filtros}
                  telefono={this.props.telefono}
                  direccion={this.props.direccion}
                  ciudad={this.props.ciudad}
                  url={this.props.url}
                />
              </PDFViewer>
            </div>
          );
        case "3":
          return (
            <div>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "flex-end"
                }}
              >
                <Button
                  variant="contained"
                  color="primary"
                  onClick={this.props.showReport}
                >
                  Volver
                </Button>
              </div>
              <PDFViewer style={{ width: "80%", height: "100vh" }}>
                <TipoAmpRes
                  data={this.props.reports}
                  filtros={this.props.filtros}
                  telefono={this.props.telefono}
                  direccion={this.props.direccion}
                  ciudad={this.props.ciudad}
                  url={this.props.url}
                />
              </PDFViewer>
            </div>
          );
        case "4":
          return (
            <div>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "flex-end"
                }}
              >
                <Button
                  variant="contained"
                  color="primary"
                  onClick={this.props.showReport}
                >
                  Volver
                </Button>
              </div>
              <PDFViewer style={{ width: "80%", height: "100vh" }}>
                <TipoApelacion
                  data={this.props.reports}
                  filtros={this.props.filtros}
                  telefono={this.props.telefono}
                  direccion={this.props.direccion}
                  ciudad={this.props.ciudad}
                  url={this.props.url}
                />
              </PDFViewer>
            </div>
          );
        case "5":
          return (
            <div>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "flex-end"
                }}
              >
                <Button
                  variant="contained"
                  color="primary"
                  onClick={this.props.showReport}
                >
                  Volver
                </Button>
              </div>
              <PDFViewer style={{ width: "80%", height: "100vh" }}>
                <TipoMonto
                  data={this.props.reports}
                  filtros={this.props.filtros}
                  telefono={this.props.telefono}
                  direccion={this.props.direccion}
                  ciudad={this.props.ciudad}
                  url={this.props.url}
                />
              </PDFViewer>
            </div>
          );
        case "6":
          return (
            <div>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "flex-end"
                }}
              >
                <Button
                  variant="contained"
                  color="primary"
                  onClick={this.props.showReport}
                >
                  Volver
                </Button>
              </div>
              <PDFViewer style={{ width: "80%", height: "100vh" }}>
                <TipoFechFutu
                  data={this.props.reports}
                  filtros={this.props.filtros}
                  telefono={this.props.telefono}
                  direccion={this.props.direccion}
                  ciudad={this.props.ciudad}
                  url={this.props.url}
                />
              </PDFViewer>
            </div>
          );
        default:
          return (
            <div>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "flex-end"
                }}
              >
                <Button
                  variant="contained"
                  color="primary"
                  onClick={this.props.showReport}
                >
                  Volver
                </Button>
              </div>
            </div>
          );
      }
    } else {
      return (
        <div>
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "flex-end"
            }}
          >
            <Button
              variant="contained"
              color="primary"
              onClick={this.props.showReport}
            >
              Volver
            </Button>
          </div>
          {/* <PDFViewer style={{ width: "80%", height: "100vh" }}>*/}

          <TipoCasoC data={this.props.reports} filtros={this.props.filtros} />

          {/*</PDFViewer>*/}
        </div>
      );
    }
  }
}

export default PdfGenerador;
